module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/safe-08f4aa4c60095618575300238ffd0e5f.svg";